// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__J9SaF","searchBox":"Navigation_searchBox__b5q4E","rightPart":"Navigation_rightPart__GLcDf"};